import React from 'react'

// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'
import AppFormikRadio from 'utlis/helpers/forms/AppFormikRadio'

export default function PageRightView(props) {
    // props
    const {
        formik
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fw-600 st-text-color2 mb-2">Pricing</p>

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows"} // class name for main wrapper
                        labelName={"Cost Price"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Cost Price"} // placeholder for the input
                        formikFieldName={"costPrice"} // important: formik value name for the input
                    />

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows"} // class name for main wrapper
                        labelName={"Price"} // label name
                        isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Price"} // placeholder for the input
                        formikFieldName={"price"} // important: formik value name for the input
                    />

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows mb-0"} // class name for main wrapper
                        labelName={"Promo Price"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Promo Price"} // placeholder for the input
                        formikFieldName={"promoPrice"} // important: formik value name for the input
                    />
                </div>
            </div>

            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fw-600 st-text-color2 mb-2">Inventory</p>

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows"} // class name for main wrapper
                        labelName={"Stock"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Stock"} // placeholder for the input
                        formikFieldName={"stock"} // important: formik value name for the input
                    />

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows"} // class name for main wrapper
                        labelName={"Low Stock"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Low Stock"} // placeholder for the input
                        formikFieldName={"lowStock"} // important: formik value name for the input
                    />

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows"} // class name for main wrapper
                        labelName={"Max Order Quantity"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Max Order Quantity"} // placeholder for the input
                        formikFieldName={"maxOrderQuantity"} // important: formik value name for the input
                    />

                    {/* form field */}
                    <AppFormikInput
                        inputType={"number"}
                        formik={formik} // formik object
                        stFormClass={"form-sm no-arrows mb-0"} // class name for main wrapper
                        labelName={"Min Order Quantity"} // label name
                        // isRequired={true} // is this field is required or not to show the red star sign
                        placeholder={"Min Order Quantity"} // placeholder for the input
                        formikFieldName={"minOrderQuantity"} // important: formik value name for the input
                    />
                </div>
            </div>

            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fw-600 st-text-color2 mb-2">Product Availability</p>

                    {/* form field */}
                    <AppFormikRadio
                        formik={formik} // formik object
                        labelClass={"align-items-center mb-0"} // class name for main wrapper
                        checkedText={"Enabled"} // name when the radio is checked
                        unCheckedText={"Disabled"} // name when the radio is checked
                        // isRequired={true} // is this field is required or not to show the red star sign
                        formikFieldName={"status"} // important: formik value name for the input
                    />

                </div>
            </div>
        </React.Fragment>
    )
}
